import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Badge, Tabs } from 'antd';
import EmailVerified from './EmailVerified';
import EmailNotVerified from './EmailNotVerified';
import RejectedList from './Rejected';
import AcceptedList from './Accepted';
import { useTabQueryGroup } from '../../../../Utils/useTabQueryGroup';
import { useTagQuerySync } from '../../../../Utils/useTagQuerySync';
import useRouteQuery from '../../../../Utils/useRouterQuery';
import { useUnreadEmailUsers } from '../../../../Hooks/TT_ELD/NewAccounts';

const NewAccounts = () => {
  const em_not = useTabQueryGroup('em_not');
  const em_ver = useTabQueryGroup('em_ver');
  const ac = useTabQueryGroup('ac');
  const re = useTabQueryGroup('re');

  const [tabKey, setTabKey] = useRouteQuery('1', 'tabKey', (v) => String(v));
  useTagQuerySync(
    { en_US: 'New Accounts', zh_CN: '' },
    'account',
    {
      tabKey,
      em_not_companyName: em_not.companyName,
      em_not_username: em_not.username,
      em_not_email: em_not.email,
      em_not_skip: em_not.skip,
      em_ver_companyName: em_ver.companyName,
      em_ver_username: em_ver.username,
      em_ver_email: em_ver.email,
      em_ver_skip: em_ver.skip,
      ac_companyName: ac.companyName,
      ac_username: ac.username,
      ac_email: ac.email,
      ac_skip: ac.skip,
      re_companyName: re.companyName,
      re_username: re.username,
      re_email: re.email,
      re_skip: re.skip,
    },
    {
      tabKey: setTabKey,
      em_not_companyName: em_not.setCompanyName,
      em_not_username: em_not.setUsername,
      em_not_email: em_not.setEmail,
      em_not_skip: em_not.setSkip,
      em_ver_companyName: em_ver.setCompanyName,
      em_ver_username: em_ver.setUsername,
      em_ver_email: em_ver.setEmail,
      em_ver_skip: em_ver.setSkip,
      ac_companyName: ac.setCompanyName,
      ac_username: ac.setUsername,
      ac_email: ac.setEmail,
      ac_skip: ac.setSkip,
      re_companyName: re.setCompanyName,
      re_username: re.setUsername,
      re_email: re.setEmail,
      re_skip: re.setSkip,
    },
  );

  const { data, refetch } = useUnreadEmailUsers();

  const items = [
    {
      label: (
        <span>
          Email Not Verified
          <Badge
            className="blue-badge"
            count={data?.emailNotVerifiedUsersCount}
            size="default"
            style={{ marginLeft: 8 }}
          />
        </span>
      ),
      key: '1',
      children: (
        <EmailNotVerified
          companyName={em_not.companyName}
          setCompanyName={em_not.setCompanyName}
          username={em_not.username}
          setUsername={em_not.setUsername}
          email={em_not.email}
          setEmail={em_not.setEmail}
          skip={em_not.skip}
          setSkip={em_not.setSkip}
          reload={refetch}
        />
      ),
      icon: <CloseCircleOutlined rev={undefined} />,
    },
    {
      label: (
        <span>
          Email Verified
          <Badge
            count={data?.emailVerifiedUsersCount}
            size="default"
            style={{ marginLeft: 8 }}
            className="blue-badge"
          />
        </span>
      ),
      key: '2',
      children: (
        <EmailVerified
          companyName={em_ver.companyName}
          setCompanyName={em_ver.setCompanyName}
          username={em_ver.username}
          setUsername={em_ver.setUsername}
          email={em_ver.email}
          setEmail={em_ver.setEmail}
          skip={em_ver.skip}
          setSkip={em_ver.setSkip}
          reload={refetch}
        />
      ),
      icon: <CheckCircleOutlined rev={undefined} />,
    },
    {
      label: <span>Accepted</span>,
      key: '3',
      children: (
        <AcceptedList
          companyName={ac.companyName}
          setCompanyName={ac.setCompanyName}
          username={ac.username}
          setUsername={ac.setUsername}
          email={ac.email}
          setEmail={ac.setEmail}
          skip={ac.skip}
          setSkip={ac.setSkip}
        />
      ),
      icon: <CheckCircleOutlined rev={undefined} />,
    },
    {
      label: <span>Rejected</span>,
      key: '4',
      children: (
        <RejectedList
          companyName={re.companyName}
          setCompanyName={re.setCompanyName}
          username={re.username}
          setUsername={re.setUsername}
          email={re.email}
          setEmail={re.setEmail}
          skip={re.skip}
          setSkip={re.setSkip}
        />
      ),
      icon: <CheckCircleOutlined rev={undefined} />,
    },
  ];
  const handleTabChange = (key: string) => {
    setTabKey(key);
  };
  return (
    <div className="mainPage">
      <Tabs
        activeKey={tabKey}
        onTabClick={handleTabChange}
        items={items.map((tab) => {
          return {
            label: tab.label,
            key: tab.key,
            children: tab.children,
            // icon: tab.icon,
          };
        })}
      />
    </div>
  );
};

export default NewAccounts;
